import { reduxForm, Field } from 'redux-form';
import { Grid } from 'semantic-ui-react';
import React from 'react';

import { VENDORLINK_PREVIEW_FORM_NAME, InputMode } from 'Common/FormEnum';
import { VendorLinkFieldEnum } from 'Common/Constants/SISIntegration';
import { InputField } from 'Common/SemanticWrapper';

const VendorLinkPreviewFormContainer = props => {
  return (
    <Grid style={{ height: '140px' }}>
      <Grid.Column width="6">
        <Field
          name={VendorLinkFieldEnum.StudentId}
          onKeyDown={props.handleKeyDown}
          onChange={props.onChange}
          disabled={props.loading}
          mode={InputMode.Integer}
          loading={props.loading}
          component={InputField}
          label="Student Id"
          maxLength="12"
          autoFocus
        />
      </Grid.Column>
    </Grid>
  );
};

const validate = values => {
  const errors = {};

  if (!values[VendorLinkFieldEnum.StudentId]) {
    errors[VendorLinkFieldEnum.StudentId] = 'Student Id is required';
  }

  return errors;
};

export const VendorLinkPreviewForm = reduxForm({
  form: VENDORLINK_PREVIEW_FORM_NAME,
  validate,
  enableReinitialize: true,
})(VendorLinkPreviewFormContainer);



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/VendorLinkPreviewStep/VendorLinkPreviewForm.js